// this is an autogenerated file from App/Account/Content/Tasks/New/Content/Board/data.graphql
import { gql } from 'Data/Api'

export default gql`
query app__App_Account_Content_Tasks_New_Content_Board($id: uuid!, $current_user_id: uuid!) {
  tasks_boards_by_pk(id: $id) {
    id
    name
    metadata
    stages {
      id
      text: name
      order
      done
      tasks_aggregate {
        aggregate {
          count
        }
      }
      subscribers(where: { user_id: { _eq: $current_user_id } }) {
        id
      }
    }
  }
}

`